import { j as jsxRuntimeExports } from './../../../../../ext/react/jsx-runtime.js';
import { Base } from '../../../Internal/Base/Base.js';

const pathStrings = {
    24: [
        'M4 13a4.002 4.002 0 013.776 2.676A3.999 3.999 0 0114 19a4.002 4.002 0 01-7.776 1.324A3.999 3.999 0 010 17c0-2.21 1.79-4 4-4zm6 4a2 2 0 10-.001 3.999A2 2 0 0010 17zm-6-2a2 2 0 10-.001 3.999A2 2 0 004 15zM21.007 3C22.108 3 23 3.904 23 5.002v9.996A1.998 1.998 0 0121.004 17H15v-2h.584L21 9.584V5.002S20.997 5 21.007 5H10.414L5 10.414V11H3V5.003C3 3.899 3.89 3 4.993 3h16.014zM21 12.414L18.414 15h2.587L21 12.414zM13 6c1.763 0 3 1.856 3 4s-1.237 4-3 4-3-1.856-3-4 1.237-4 3-4zm0 2c-.447 0-1 .83-1 2s.553 2 1 2c.447 0 1-.83 1-2s-.553-2-1-2zM7.584 5H4.998L5 7.585 7.584 5z',
    ],
};
const IconMoney = ({ size, className, ...rest }) => {
    const paths = pathStrings[size].map((d, i) => (jsxRuntimeExports.jsx("path", { d: d, fillRule: "evenodd" }, String(i))));
    return (jsxRuntimeExports.jsx(Base, { as: "svg", height: size, width: size, viewBox: `0 0 ${size} ${size}`, className: className, xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", preserveAspectRatio: "xMidYMid meet", fill: "currentColor", ...rest, children: paths }));
};
IconMoney.displayName = 'IconMoney';

export { IconMoney };
//# sourceMappingURL=IconMoney.js.map
